import Checkbox from "@mui/material/Checkbox";
import TableCell from "@mui/material/TableCell";
import Tooltip from "@mui/material/Tooltip";
import { STICKY_BODY_Z_INDEX, stickyColumnSx } from "./tableLayout";

interface SelectRowCheckboxCellProps {
  checked: boolean;
  /** Non-null when the row cannot be picked: the box is dead and this says why on hover. */
  blockedReason: string | null;
  /** Names the route the box belongs to — a checkbox column has no header text to read out. */
  label: string;
  onChange: () => void;
}

/**
 * The selection box in the table's first column, for one row.
 *
 * A row whose ตรวจแล้ว this caller cannot write is not selectable at all: picking it would
 * only produce a skip the reviewer could have predicted from what was on screen. The reason
 * rides on the box, because a dead checkbox that explains nothing reads as a bug.
 *
 * The span is what carries the hover — a disabled input fires no pointer events of its own.
 */
export default function SelectRowCheckboxCell({
  checked,
  blockedReason,
  label,
  onChange,
}: SelectRowCheckboxCellProps) {
  return (
    <TableCell padding="checkbox" sx={stickyColumnSx(0, STICKY_BODY_Z_INDEX)}>
      <Tooltip title={blockedReason ?? ""}>
        <span>
          <Checkbox
            checked={checked}
            disabled={Boolean(blockedReason)}
            onChange={onChange}
            inputProps={{ "aria-label": label }}
          />
        </span>
      </Tooltip>
    </TableCell>
  );
}
